import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/root/store';

import { moduleName } from '../constants';
import type { PermissionManagerSlice } from '../types';

const permissionManagerModuleSel = (state: RootState) =>
  state[moduleName] as PermissionManagerSlice;

export const timeStampSel = createSelector(
  permissionManagerModuleSel,
  ({ timeStamp }) => timeStamp,
);
